import { getLink } from '../../../../utils/utils';

import author from './author';

const content = {
  rus: (
    `
      <div class="poem">
        <p class="poem-block mb-5 text-center">
          * * *
        </p>

        <p class="poem-block mb-3">
          Как обступает нас круговорот<br/>
          Бессчётных будней, пятниц и суббот!<br/>
          В семь дней навеки жизнь заключена,<br/>
          Из них не может вырваться она.
        </p>
        
        <p class="poem-block mb-3">
          Гори в огне, в болоте волочись,
          Срывайся в пропасть, устремляйся ввысь – <br/>
          Не вырвешься из скованных цепей<br/>
          Идущих мерно друг за другом дней.
        </p>
        
        <p class="poem-block mb-3">
          Ты в этот круг попался навсегда:<br/>
          Четверг, суббота, пятница, среда…
        </p>
      </div>
    `
  )
}

const itemName = {
  rus: 'Как обступает нас круговорот'
}
const itemDate = {
  rus: '28 мая 2021 г.'
}

const item = {
  itemlink: getLink(itemName.rus),
  rus:{
    itemName: itemName.rus,
    itemDate: itemDate.rus,
    itemContent: content.rus,
    itemAuthor: author.rus
  }
}


export default item;